import { RealTimeLineChart } from "./RealTimeLineChart";
export default RealTimeLineChart;
